import React from 'react'
import PropTypes from 'prop-types'

import { Helmet } from 'react-helmet'

import axios from 'axios'

import { InvisibleSmartCaptcha } from '@yandex/smart-captcha'

const { instanceOf } = PropTypes
import { Cookies } from 'react-cookie'
import withSafeCookies from './withSafeCookies'

import WelcomePage from './pages/WelcomePage'
import WelcomeLogin from './pages/WelcomeLogin'

import Main from './pages/Main'
import TextPage from './pages/TextPage'
import Cart from './pages/Cart'
import Oformlenie from './pages/Oformlenie'
import Spasibo from './pages/Spasibo'
import Lk from './pages/Lk'
import Akcii from './pages/Akcii'
import LastOrder from './pages/LastOrder'
import About from './pages/About'
import Delivery from './pages/Delivery'
import Payment from './pages/Payment'
import Kontakti from './pages/Kontakti'
import Urinfo from './pages/Urinfo'
import Notifications from './pages/Notifications'

import SetLocation from './block/SetLocation'
import ProductWin from './block/ProductWin'
import ProductWin2 from './block/ProductWin2'
import Usloviya from './block/Usloviya'
import FeedbackForm from './block/FeedbackForm'
import LeftMenu from './block/LeftMenu'

import './config.scss'

// Компонент для уведомлений
const Notification = ({ message, type = 'info', onClose, visible }) => {
  if (!visible) return null;

  const bgColor = type === 'error' ? 'bg-red-500' : 
                  type === 'success' ? 'bg-green-500' : 
                  type === 'warning' ? 'bg-yellow-500' : 
                  'bg-blue-500';

  return (
    <div className="fixed top-4 right-4 z-50 max-w-sm ml-4">
      <div className={`${bgColor} rounded-lg shadow-lg p-4 flex items-start gap-3 text-white`}>
        <div className="w-5 h-5 rounded-full bg-white bg-opacity-20 flex items-center justify-center flex-shrink-0 mt-0.5">
          {type === 'error' && (
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z" stroke="white" strokeWidth="0.5"/>
              <path d="M6 4V6.5" stroke="white" strokeWidth="0.5" strokeLinecap="round"/>
              <path d="M6 8H6.005" stroke="white" strokeWidth="0.5" strokeLinecap="round"/>
            </svg>
          )}
          {type === 'success' && (
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 3L4.5 8.5L2 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          )}
        </div>
        <div className="flex-1">
          <p className="text-sm font-medium mb-1">
            {type === 'error' ? 'Ошибка' : 
             type === 'success' ? 'Успешно' : 
             type === 'warning' ? 'Внимание' : 'Информация'}
          </p>
          <p className="text-sm">{message}</p>
        </div>
        <button
          onClick={onClose}
          className="text-white text-opacity-70 hover:text-opacity-100 transition-colors"
        >
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 13L13 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            <path d="M13 13L1 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
        </button>
      </div>
    </div>
  );
};

Notification.propTypes = {
  message: PropTypes.string,
  type: PropTypes.oneOf(['info', 'success', 'error', 'warning']),
  onClose: PropTypes.func,
  visible: PropTypes.bool
};

class App extends React.Component {

  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  }

  constructor(props) {
    super(props)
    const { cookies } = this.props

    this.state = {
      loading: true,
      data: props?.data || {},
      protocol: `https`,
      assets_path: `SDF4fgSDG_assets`,
      user: {
        id: 0
      },
      smartCaptchaKey: `ysc1_BhLAY5ykebwvbOkPkPIwL4i6kgWlcxFdfqYbi03af70bb798`,
      token: ``,
      captchaKey: 1,
      showLocation: false,
      location: {
        isset: false,
        coordinates: [],
        restaurantId: null,
        zoneId: null,
        address: ``,
        city: ``,
        street: ``,
        house: ``,
        entrance: ``,
        intercom: ``,
        floor: ``,
        apartment: ``,
        comment: ``
      },
      favorite: props?.data?.favorite || [],
      product_win: {
        show: false,
        loading: true,
        data: {}
      },
      page_content: 'page-content',
      restaurant_id: 0,
      restaurant: {
        adres: ``,
        id: 0,
        worktime: ``,
        delivery_prices: [],
        akcii: [],
        recomended: [],
        notifications: [],
        notifications_md5: ``,
        new: false
      },
      menu: [],
      lk_data: {
        loaded: false
      },
      feedback_form: false,
      notification: {
        visible: false,
        message: '',
        type: 'info'
      },
      cart: {
        'result': false,
        'items': [],
        'total_items': 0,
        'total_price': 0
      },
      usloviyaWin: false,
      lastOrder: {
        number: ``
      },
      leftMenu: false,
      width: 750,
      requestBlocked: false,
      pendingMenuRequests: [],
      isSubmittingOrder: false
    }

    this.changeLocation = this.changeLocation.bind(this);
    this.deleteLocation = this.deleteLocation.bind(this);
    this.changeDeliveryType = this.changeDeliveryType.bind(this);
    this.setPickupRest = this.setPickupRest.bind(this);
    this.changeFavorite = this.changeFavorite.bind(this);
    this.openProductWin = this.openProductWin.bind(this);
    this.closeProductWin = this.closeProductWin.bind(this);
    this.showFeedbackForm = this.showFeedbackForm.bind(this);
    this.closeFeedbackForm = this.closeFeedbackForm.bind(this);
    this.handleAddToCart = this.handleAddToCart.bind(this);
    this.getRestaurant = this.getRestaurant.bind(this);
    this.getMenu = this.getMenu.bind(this);
    this.getMenuLegacy = this.getMenuLegacy.bind(this);
    this.getMenuProducts = this.getMenuProducts.bind(this);
    this.getLk = this.getLk.bind(this);
    this.getCart = this.getCart.bind(this);
    this.handleChangeCountCart = this.handleChangeCountCart.bind(this);
    this.handleChangeExtraCountCart = this.handleChangeExtraCountCart.bind(this);
    this.sendPromocode = this.sendPromocode.bind(this);
    this.onOrderSubmit = this.onOrderSubmit.bind(this);
    this.saveUser = this.saveUser.bind(this);
    this.leftMenu = this.leftMenu.bind(this);
    this.blockRequests = this.blockRequests.bind(this);
    this.unblockRequests = this.unblockRequests.bind(this);
  }

  // Функции для блокировки/разблокировки запросов
  blockRequests() {
    this.setState({ requestBlocked: true });
  }

  unblockRequests() {
    this.setState({ requestBlocked: false }, () => {
      // После разблокировки обрабатываем накопившиеся запросы
      this.processPendingMenuRequests();
    });
  }

  // Обработка отложенных запросов меню
  processPendingMenuRequests() {
    const { pendingMenuRequests } = this.state;
    if (pendingMenuRequests.length > 0) {
      const requests = [...pendingMenuRequests];
      this.setState({ pendingMenuRequests: [] }, () => {
        requests.forEach(key => this.getMenuProducts(key));
      });
    }
  }

  // Функция для показа уведомлений
  showNotification = (message, type = 'info') => {
    this.setState({
      notification: {
        visible: true,
        message,
        type
      }
    });

    // Автоматическое скрытие через 5 секунд
    setTimeout(() => {
      this.hideNotification();
    }, 5000);
  };

  // Функция для скрытия уведомлений
  hideNotification = () => {
    this.setState({
      notification: {
        visible: false,
        message: '',
        type: 'info'
      }
    });
  };

  setToken = ( token ) => {
    this.setState({
      token: token
    })
  }

  errorCapcha = () => {
    const { captchaKey } = this.state
    this.setState({
      error_massage: 'Произошла ошибка при проверке ваших данных, попробуйте позже!',
      captchaKey: captchaKey + 1
    })
  }

  getRestaurant( id ) {
    const { restaurant_id, data, user } = this.state,
    { cookies } = this.props

    if( id == restaurant_id ) return;

    this.setState({
      loading: true
    }, () => {
      axios.post(`https://${window.location.host}`, {
        content_type: 'application/json',
        action: 'load_restaurant',
        id: id
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Request-Source': 'Node.js'
        }
      }).then( ( response ) => {

        // Получаем текущий MD5 из cookies
        const currentNotificationsMd5 = cookies.get('notifications_md5') || ''
        const newNotificationsMd5 = response.data?.notifications_md5 || ''
        
        // Сравниваем MD5
        const notifications_new = newNotificationsMd5 !== currentNotificationsMd5

        //window.console.log( notifications_new, newNotificationsMd5, currentNotificationsMd5 )

        var rdata = response.data
        rdata.new = notifications_new

        this.setState({
          restaurant: rdata,
          restaurant_id: id,
          loading: false
        }, () => {
          this.getCart()
          /* if ([1, 3, 4].includes(data?.template) && user?.id != 0) this.getMenu() модерация */
          if ([1, 3, 4].includes(data?.template)) this.getMenu()
          if ([8, 10, 11].includes(data?.template) && user?.id != 0) this.getLk()
        })
      })
      .catch((error) => {
        this.setState({
          loading: false
        })
        this.showNotification('Ошибка загрузки ресторана', 'error')
        setTimeout(() => this.getRestaurant( id ), 2000)
        console.error('Ошибка запроса:', error);
      })
    })
  }

  // Модифицированная функция загрузки продуктов меню
  getMenuProducts(key) {
    const { menu, requestBlocked, pendingMenuRequests } = this.state;

    // Если запросы заблокированы, добавляем в очередь
    if (requestBlocked) {
      this.setState({
        pendingMenuRequests: [...pendingMenuRequests, key]
      });
      return;
    }

    axios.post(`https://${window.location.host}`, {
      content_type: 'application/json',
      action: 'load_menu_products',
      razdel: menu[key]?.id
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then((response) => {
      menu[key].products = response.data
      menu[key].loaded = true
      this.setState({
        menu: menu
      }, () => {
        if (key < (menu.length - 1)) this.getMenuProducts(key + 1)
      })
    })
    .catch((error) => {
      setTimeout(() => {
        this.getMenuProducts(key)
      }, 1500)
      console.error('Ошибка запроса:', error);
    })
  }

  // Меню грузится одним запросом: разделы вместе с позициями
  getMenu() {
    const { restaurant_id } = this.state

    axios.post(`https://${window.location.host}`, {
      content_type: 'application/json',
      action: 'load_menu_full',
      id: restaurant_id
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then( ( response ) => {
      const menu = (response.data?.menu || []).map(section => ({
        ...section,
        products: section.products || [],
        loaded: true
      }))

      this.setState({
        menu: menu
      })
    })
    .catch((error) => {
      console.error('Ошибка запроса (load_menu_full):', error);
      // Резервный путь: разделы отдельно, позиции по одному
      this.getMenuLegacy()
    })
  }

  getMenuLegacy() {
    const { restaurant_id } = this.state

    axios.post(`https://${window.location.host}`, {
      content_type: 'application/json',
      action: 'load_menu',
      id: restaurant_id
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then( ( response ) => {
      this.setState({
        menu: response.data?.menu || []
      }, () => {
        this.getMenuProducts( 0 )
      })
    })
    .catch((error) => {
      this.showNotification('Ошибка загрузки меню', 'error');
      setTimeout(() => this.getMenu(), 2000)
      console.error('Ошибка запроса:', error);
    })
  }

  getLk() {
    axios.post(`https://${window.location.host}`, {
      content_type: 'application/json',
      action: 'load_lk'
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then( ( response ) => {
      this.setState({
        lk_data: response.data
      })
    })
    .catch((error) => {
      this.showNotification('Ошибка загрузки личного кабинета', 'error')
      setTimeout(() => this.getLk(), 2000)
      console.error('Ошибка запроса:', error)
    })
  }

  getUser() {
    const main = this

    axios.post(`https://${window.location.host}`, {
      content_type: 'application/json',
      action: 'load_user'
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then( ( response ) => {
      main.setState({
        user: response.data,
        loading: false
      }, () => {
        if(response.data?.delivery_type != `pickup`) main.showLocationChange( !response.data?.location?.isset )
        main.getRestaurant( response.data?.restaurant_id )
      })
    })
    .catch((error) => {
      main.setState({
        loading: false
      })
      this.showNotification('Ошибка загрузки пользователя', 'error')
      setTimeout(() => this.getUser(), 2000)
      console.error('Ошибка запроса:', error)
    })
  }

  showLocationChange = ( stat ) => {
    this.setState({
      showLocation: stat
    })
  }

  changeLocation( data ) {
    axios.post(`https://${window.location.host}`, {
      content_type: 'application/json',
      action: 'set_location',
      json: JSON.stringify( data )
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then( ( response ) => {
      if(!response.data?.id) {
        this.showNotification('Ошибка сохранения адреса. ' + response.data?.massage, 'error');
      } else {
        this.setState({
          user: response.data
        }, () => {
          this.getRestaurant( response.data?.restaurant_id )
        })
        this.showNotification('Адрес успешно сохранен', 'success');
        this.showLocationChange( false );
      }
    })
    .catch((error) => {
      this.showNotification('Ошибка сохранения адреса', 'error');
      console.error('Ошибка запроса:', error);
    })
  }

  deleteLocation( adres ) {
    const main = this

    axios.post(`https://${window.location.host}`, {
      content_type: 'application/json',
      action: 'delete_location',
      adres: adres
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then( ( response ) => {
      main.setState({
        user: response.data
      }, () => {
        main.getRestaurant( response.data?.restaurant_id )
      })
      this.showNotification('Адрес удален', 'success');
    })
    .catch((error) => {
      this.showNotification('Ошибка удаления адреса', 'error');
      console.error('Ошибка запроса:', error);
    })
  }

  changeDeliveryType( type ) {
    const main = this

    axios.post(`https://${window.location.host}`, {
      content_type: 'application/json',
      action: 'change_delivery_type',
      type: type
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then( ( response ) => {
      main.setState({
        user: response.data
      }, () => {
        main.getRestaurant( response.data?.restaurant_id )
      })
      // this.showNotification('Тип доставки изменен', 'success');
    })
    .catch((error) => {
      this.showNotification('Ошибка изменения типа доставки', 'error');
      console.error('Ошибка запроса:', error);
    })
  }

  setPickupRest( id ) {
    const main = this

    axios.post(`https://${window.location.host}`, {
      content_type: 'application/json',
      action: 'set_pickup_rest',
      type: id
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then( ( response ) => {
      main.setState({
        user: response.data
      }, () => { 
        main.showLocationChange( false )
        main.getRestaurant( response.data?.restaurant_id )
      })
      this.showNotification('Ресторан для самовывоза выбран', 'success');
    })
    .catch((error) => {
      this.showNotification('Ошибка выбора ресторана', 'error');
      console.error('Ошибка запроса:', error);
    })
  }

  changeFavorite( id ) {
    axios.post(`https://${window.location.host}`, {
      content_type: 'application/json',
      action: 'set_favorite',
      id: id
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then( ( response ) => {
      this.setState({
        favorite: response.data?.favorite || []
      })
    })
    .catch((error) => {
      this.showNotification('Ошибка изменения избранного', 'error');
      console.error('Ошибка запроса:', error);
    })
  }

  openProductWin( id, change = true ) {

    const { product_win, user } = this.state

    if(user?.id == 0) {
      window.location = `/user/`
    }

    var new_product_win = {
      show: true,
      loading: true,
      data: {},
      scrollPosition: change ? ( window.pageYOffset || document.documentElement.scrollTop ) : product_win?.scrollPosition
    }

    this.setState({
      product_win: new_product_win
    }, () => {
      axios.post(`https://${window.location.host}`, {
        content_type: 'application/json',
        action: 'get_product',
        id: id
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Request-Source': 'Node.js'
        }
      }).then( ( response ) => {
        if( response.data?.success ) {
          new_product_win.data = response.data
          new_product_win.loading = false
          this.setState({
            product_win: new_product_win,
            page_content: 'page-content no-scroll'
          })
        }
      })
      .catch((error) => {
        this.showNotification('Ошибка загрузки товара', 'error')
        setTimeout(() => this.openProductWin( id, false ), 2000)
        console.error('Ошибка запроса:', error)
      })
    })
  }
  closeProductWin() {
    const { product_win } = this.state

    product_win.show = false
    product_win.loading = true
    product_win.data = {}

    this.setState({
      product_win: product_win,
      page_content: 'page-content'
    }, () => {
      if (product_win.scrollPosition !== undefined) {
        window.scrollTo(0, product_win.scrollPosition)
      }
    })
  }

  getCart() {
    this.setState({
      loading: true
    }, () => {
      axios.post(`https://${window.location.host}`, {
        content_type: 'application/json',
        action: 'get_cart'
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Request-Source': 'Node.js'
        }
      }).then( ( response ) => {
        this.setState({
          cart: response.data,
          loading: false
        })
      })
      .catch((error) => {
        this.setState({
          loading: false,
          cart: {
            'result': false,
            'items': [],
            'total_items': 0,
            'total_price': 0
          }
        })
        this.showNotification('Ошибка загрузки корзины', 'error')
        setTimeout(() => this.getCart(), 2000)
        console.error('Ошибка запроса:', error)
      })
    })
  }

  // Модифицированная функция добавления в корзину
  handleAddToCart(id, quantity, ingredients, polovinki = ``) {
    this.blockRequests(); // Блокируем запросы меню
    
    setTimeout( () => {
      axios.post(`https://${window.location.host}`, {
        content_type: 'application/json',
        action: 'add_to_cart',
        id: id,
        quantity: quantity,
        ingredients: ingredients,
        polovinki: polovinki
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Request-Source': 'Node.js'
        }
      }).then((response) => {
        if (response.data?.result) {
          this.setState({
            cart: response.data
          }, () => {
            this.showNotification('Товар добавлен в корзину', 'success');
            this.closeProductWin();
            this.unblockRequests(); // Разблокируем после успешного добавления
          })
        } else {
          this.showNotification('Ошибка добавления в корзину', 'error');
          this.unblockRequests(); // Разблокируем даже при ошибке
        }
      }).catch((error) => {
        this.showNotification('Ошибка добавления в корзину', 'error');
        console.error('Error adding to cart:', error);
        this.unblockRequests(); // Разблокируем при ошибке сети
      });
    }, 300 )
  }

  handleChangeCountCart(key, quantity) {
    axios.post(`https://${window.location.host}`, {
      content_type: 'application/json',
      action: 'change_in_cart',
      key: key,
      quantity: quantity
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then((response) => {
      if (response.data?.result) {
        this.setState({
          cart: response.data
        }, () => {
          //this.showNotification('Количество изменено', 'success');
          this.closeProductWin();
        })
      } else {
        this.showNotification('Ошибка добавления в корзину', 'error');
      }
    }).catch((error) => {
      this.showNotification('Ошибка добавления в корзину', 'error');
      console.error('Error adding to cart:', error);
    });
  }

  handleChangeExtraCountCart(key, quantity) {
    axios.post(`https://${window.location.host}`, {
      content_type: 'application/json',
      action: 'change_extra_in_cart',
      key: key,
      quantity: quantity
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then((response) => {
      if (response.data?.result) {
        this.setState({
          cart: response.data
        })
      } else {
        this.showNotification('Ошибка добавления в корзину', 'error');
      }
    }).catch((error) => {
      this.showNotification('Ошибка добавления в корзину', 'error');
      console.error('Error adding to cart:', error);
    });
  }

  sendPromocode( promocode ) {
    axios.post(`https://${window.location.host}`, {
      content_type: 'application/json',
      action: 'send_promocode',
      promocode: promocode
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then((response) => {
      if (response.data?.result) {
        this.setState({
          cart: response.data
        }, () => {
          this.showNotification('Промокод активирован', 'success');
          this.closeProductWin();
        })
      } else {
        this.showNotification('Промокод не подошел', 'error');
        setTimeout( () => this.getCart(), 2000 )
      }
    }).catch((error) => {
      this.showNotification('Ошибка добавления промокода', 'error');
      console.error('Error adding to cart:', error);
    });
  }

  showFeedbackForm() {
    this.setState({
      feedback_form: true
    })
  }
  closeFeedbackForm() {
    this.setState({
      feedback_form: false
    })
  }

  changeUsloviyaWin( sst ) {
    this.setState({
      usloviyaWin: sst
    })
  }

  onOrderSubmit(odata) {
    const { data, isSubmittingOrder } = this.state

    if (isSubmittingOrder) {
      this.showNotification('Заказ уже отправляется, пожалуйста, подождите...', 'warning')
      return false
    }

    this.setState({ isSubmittingOrder: true })

    axios.post(`https://${window.location.host}`, {
      content_type: 'application/json',
      action: 'send_order',
      data: odata
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then((response) => {
      if (response.data?.result) {
        if (response.data?.requires_online_payment && response.data?.payment_url !== '') {
          window.location.href = response.data?.payment_url
        } else {
          window.location.href = data?.spasibo_link || '/'
        }
      } else {
        this.showNotification(response.data?.message || 'Ошибка при отправке заказа', 'error')
        this.setState({ isSubmittingOrder: false })
      }
    }).catch((error) => {
      this.showNotification('Ошибка отправки заказа', 'error')
      console.error('Error sending order:', error)
      this.setState({ isSubmittingOrder: false })
      throw error // Пробрасываем ошибку дальше
    })
  }

  getLastOrder() {
    axios.post(`https://${window.location.host}`, {
      content_type: 'application/json',
      action: 'last_order'
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then((response) => {
      window.console.log(  )
      if( response.data?.result ) {
        this.setState({
          lastOrder: response.data?.order
        })
      } else {
        this.setState({
          lastOrder: {
            number: ``
          }
        })
      }
    }).catch((error) => {
      console.error('Error adding to cart:', error)
    })
  }

  saveUser( data, fnc ) {
    axios.post(`https://${window.location.host}`, {
      content_type: 'application/json',
      action: 'save_user',
      birthday: data?.birthday,
      email: data?.email,
      fullname: data?.fullname,
      phone: data?.phone
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then((response) => {
      if( response.data?.result ) {
        this.getUser()
      } else {
        this.showNotification(response.data?.message, 'error')
      }
      fnc()
    }).catch((error) => {
      console.error('Error adding to cart:', error)
    })
  }

  leftMenu() {
    const { leftMenu } = this.state
    this.setState({
      leftMenu: !leftMenu
    })
  }

  componentDidMount() {
    this.getUser()
    this.getLastOrder()
    this.intervalId = setInterval(() => {
      this.getLastOrder()
    }, 20000)

    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  updateWindowDimensions = () => {
    this.setState({
      width: window.innerWidth
    })
  }

  componentWillUnmount() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  renderPage() {
    const { data, protocol, assets_path, user, restaurant, menu, lk_data, favorite, cart, lastOrder, width } = this.state,
    { cookies } = this.props

    if([1,2,3,4].includes(data?.template)) return (
      <Main
        data={data}
        protocol={protocol}
        assets_path={assets_path}
        user={user}
        restaurant={restaurant}
        menu={menu}
        showLocation={() => this.showLocationChange(true)}
        changeDeliveryType={this.changeDeliveryType}
        favorite={favorite}
        changeFavorite={this.changeFavorite}
        openProductWin={this.openProductWin}
        showFeedbackForm={this.showFeedbackForm}
        showUsloviyaWin={() => this.changeUsloviyaWin(true)}
        lastOrder={lastOrder}
        cart={cart}
        leftMenu={this.leftMenu}
        width={width}
      />
    )
    if(data?.template == 5) return (
      <Cart
        data={data}
        protocol={protocol}
        assets_path={assets_path}
        user={user}
        cart={cart}
        change={this.handleChangeCountCart}
        changeExtra={this.handleChangeExtraCountCart}
        openProductWin={this.openProductWin}
        sendPromocode={this.sendPromocode}
      />
    )
    if(data?.template == 6) return (
      <Oformlenie
        assets_path={assets_path}
        data={data}
        protocol={protocol}
        user={user}
        cart={cart}
        restaurant={restaurant}
        showLocation={() => this.showLocationChange(true)}
        changeDeliveryType={this.changeDeliveryType}
        showUsloviyaWin={() => this.changeUsloviyaWin(true)}
        onOrderSubmit={this.onOrderSubmit}
      />
    )
    if(data?.template == 7) return (
      <TextPage
        data={data}
        user={user}
        showFeedbackForm={this.showFeedbackForm}
        cart={cart}
        leftMenu={this.leftMenu}
        parent={data?.parent_id}
      />
    )
    if(data?.template == 8) return (
      <Lk
        assets_path={assets_path}
        data={data}
        showFeedbackForm={this.showFeedbackForm}
        lastOrder={lastOrder}
        user={user}
        restaurant={restaurant}
        lk_data={lk_data}
        save={this.saveUser}
        tpl={`main`}
        favorite={favorite}
        changeFavorite={this.changeFavorite}
        openProductWin={this.openProductWin}
        cart={cart}
        leftMenu={this.leftMenu}
      />
    )
    if(data?.template == 9) return (
      <Akcii
        assets_path={assets_path}
        data={data}
        showFeedbackForm={this.showFeedbackForm}
        lastOrder={lastOrder}
        restaurant={restaurant}
        cart={cart}
        leftMenu={this.leftMenu}
      />
    )
    if(data?.template == 10) return (
      <Lk
        assets_path={assets_path}
        data={data}
        showFeedbackForm={this.showFeedbackForm}
        lastOrder={lastOrder}
        user={user}
        restaurant={restaurant}
        lk_data={lk_data}
        save={this.saveUser}
        tpl={`favorite`}
        favorite={favorite}
        changeFavorite={this.changeFavorite}
        openProductWin={this.openProductWin}
        cart={cart}
        leftMenu={this.leftMenu}
      />
    )
    if(data?.template == 11) return (
      <Lk
        assets_path={assets_path}
        data={data}
        showFeedbackForm={this.showFeedbackForm}
        lastOrder={lastOrder}
        user={user}
        restaurant={restaurant}
        lk_data={lk_data}
        save={this.saveUser}
        tpl={`history`}
        favorite={favorite}
        changeFavorite={this.changeFavorite}
        openProductWin={this.openProductWin}
        cart={cart}
        leftMenu={this.leftMenu}
      />
    )
    if(data?.template == 13) return (
      <Spasibo
        assets_path={assets_path}
      />
    )
    if(data?.template == 14) return (
      <LastOrder
        data={data}
        user={user}
        restaurant={restaurant}
        order={lastOrder}
        assets_path={assets_path}
      />
    )
    if(data?.template == 15) return (
      <About
        width={width}
        assets_path={assets_path}
      />
    )
    if(data?.template == 16) return (
      <Delivery
        data={data}
        user={user}
        assets_path={assets_path}
      />
    )
    if(data?.template == 17) return (
      <Payment
        data={data}
        user={user}
        assets_path={assets_path}
      />
    )
    if(data?.template == 18) return (
      <Kontakti
        data={data}
        user={user}
        assets_path={assets_path}
      />
    )
    if(data?.template == 19) return (
      <Urinfo
        data={data}
        user={user}
        assets_path={assets_path}
      />
    )
    if(data?.template == 20) return (
      <Notifications
        data={data}
        user={user}
        restaurant={restaurant}
        assets_path={assets_path}
        openProductWin={this.openProductWin}
        cookies={cookies}
      />
    )
  }

  render() {

    const {
      data,
      protocol,
      loading,
      assets_path,
      user,
      restaurant,
      smartCaptchaKey,
      token,
      captchaKey,
      showLocation,
      location,
      product_win,
      page_content,
      favorite,
      feedback_form,
      notification,
      usloviyaWin,
      leftMenu
    } = this.state

    const { get } = this.props 

    // Хост берём из данных MODX, иначе из адресной строки: сайт работает на pizzaokidoki.ru и rybkasverhy.ru
    const currentHost = data?.helmet.host || (typeof window !== 'undefined' ? window.location.host : 'pizzaokidoki.ru')

    return (
      <>
        <Helmet>
          <title>{data?.helmet.title || 'pizzaokidoki.ru'}</title>

          <base href={`${protocol}://${currentHost}/`} />

          <meta name="viewport" content="width=device-width, initial-scale=1.0, viewport-fit=cover" />
          <meta name="robots" content="all" />

          <meta name="description" content={data?.helmet.description || 'pizzaokidoki.ru'} />

          <meta property="og:type" content="website" />
          <meta property="og:title" content={data?.helmet.title || 'pizzaokidoki.ru'} />
          <meta property="og:description" content={data?.helmet.description || 'pizzaokidoki.ru'} />
          <meta property="og:image" content={`${protocol}://${currentHost}/files/images/logo.svg`} />
          <meta property="og:url" content= {`${protocol}://${currentHost}`} />

          <link href="favicon.ico" rel="shortcut icon" type="image/vnd.microsoft.icon" />
          <link rel="stylesheet" href={`${protocol}://${currentHost}/SDF4fgSDG_assets/fonts/Inter/stylesheet.css`} />
          <link rel="stylesheet" href={`${protocol}://${currentHost}/SDF4fgSDG_assets/fonts/Manrope/stylesheet.css`} />
        </Helmet>

        {loading ?
          <WelcomePage
            assets_path={assets_path}
          />
        :
          <>
            {user?.id == 0 ?
              <>
                {/*([ 1, 5, 6, 8, 10, 11, 14 ].includes(data?.template)) ? модерация */}
                {([ 5, 6, 8, 10, 11, 14 ].includes(data?.template)) ? 
                  <>
                    <WelcomeLogin
                      assets_path={assets_path}
                      token={token}
                      showFeedbackForm={this.showFeedbackForm}
                      host={data?.helmet.host}
                    />
                    <InvisibleSmartCaptcha
                      key={captchaKey}
                      sitekey={smartCaptchaKey}
                      onSuccess={this.setToken}
                      shieldPosition={`top-left`}
                      onNetworkError={this.errorCapcha}
                      onJavaScriptError={this.errorCapcha}
                      onTokenExpired={this.errorCapcha}
                      visible={true}
                    />
                  </>
                :
                  <>
                    {this.renderPage()}
                  </>
                }
              </>
            :
              <>
                <div className={page_content}>
                  {this.renderPage()}
                </div>
                <SetLocation
                  assets_path={assets_path}
                  show={showLocation}
                  change={this.showLocationChange}
                  location={location}
                  restaurants={data?.locations}
                  onZoneSelected={this.changeLocation}
                  deliveryPrices={restaurant?.delivery_prices || []}
                  type={user?.delivery_type}
                  locations={user?.locations}
                  deleteLocation={this.deleteLocation}
                  changeDeliveryType={this.changeDeliveryType}
                  setPickupRest={this.setPickupRest}
                  showUsloviyaWin={() => this.changeUsloviyaWin(true)}
                />
                {get?.test == 1 ?
                  <ProductWin2
                    key={product_win?.data?.id || 0}
                    assets_path={assets_path}
                    product={product_win}
                    favorite={favorite}
                    changeFavorite={this.changeFavorite}
                    openProductWin={this.openProductWin}
                    closeProductWin={this.closeProductWin}
                    addToCart={this.handleAddToCart}
                  />
                :
                  <ProductWin
                    key={product_win?.data?.id || 0}
                    assets_path={assets_path}
                    product={product_win}
                    favorite={favorite}
                    changeFavorite={this.changeFavorite}
                    openProductWin={this.openProductWin}
                    closeProductWin={this.closeProductWin}
                    addToCart={this.handleAddToCart}
                  />
                }
                <Usloviya
                  prices={restaurant?.delivery_prices || []}
                  show={usloviyaWin}
                  close={() => this.changeUsloviyaWin(false)}
                />
              </>
            }
            <FeedbackForm
              assets_path={assets_path}
              show={feedback_form}
              close={this.closeFeedbackForm}
            />
            <Notification
              visible={notification.visible}
              message={notification.message}
              type={notification.type}
              onClose={this.hideNotification}
            />
            <LeftMenu
              user={user}
              restaurant={restaurant}
              data={data}
              stat={leftMenu}
              fnc={this.leftMenu}
            />
          </>
        }
      </>
    )
  }
}

App.propTypes = {
  data: PropTypes.object,
  get: PropTypes.object
}

export default withSafeCookies(App)